import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import _UserNav from './_UserNav.scss';
import {connect} from 'react-redux';
import {ShowIf} from 'components/utils';
import {logout} from 'base/actions';
import {toastr} from 'react-redux-toastr';
import {UploadImage} from 'components/UI/Image';

class UserNav extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  signout() {
    this.props.dispatch(logout()).then(res => {
      // go home
      toastr.success("Thành công", "Bạn đã đăng xuất thành công");
      this.props.history.push('/');
    })
  }

  render() {
    return (
      <div className='wrap-flexbox wrap-center'>
        <div className='user-img-wrap'>
          <ShowIf condition={this.props.auth && this.props.auth.isAuthenticated && this.props.auth.user.avatar}>
            <UploadImage transform="crop" width={44} height={44} type='USER' image={this.props.auth.user
              ? this.props.auth.user.avatar
              : ''}/>
          </ShowIf>
          <ShowIf condition={!this.props.auth || !this.props.auth.isAuthenticated || !this.props.auth.user.avatar}>
            <img src={require('assets/images/header/default-avata.jpg')} className='user-img' alt=''/>
          </ShowIf>

        </div>
        <ShowIf condition={!this.props.auth.isAuthenticated}>
          <div className='user-link-wrap'>
            <div className='user-top-content'>
              <Link to='/signin' className='user-link'>Đăng nhập</Link>
              <Link to='/signup' className='user-link'>Đăng ký</Link>
            </div>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.auth.isAuthenticated}>
          <div className='user-link-wrap'>
            <div className='user-top-content'>
              <Link to='/profile' className='user-link'>Tài khoản của tôi</Link>
            </div>
            <div className='user-bottom-content'>
              <a href='javascript:void(0)' className='user-link' onClick={this.signout.bind(this)}>Đăng xuất</a>
            </div>
          </div>
        </ShowIf>
      </div>
    )
  }
}

const bindStateToProps = state => {
  return {auth: state.auth}
}

export default withRouter(connect(bindStateToProps)(UserNav));



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/UserNav.jsx